import {
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { ModalController } from '@ionic/angular';

import { DataService } from '../../services/data.service';
import { PrintService } from '../../services/print.service';
import * as qz from 'qz-tray';

@Component({
  selector: 'app-pos-print',
  templateUrl: './pos-print.page.html',
  styleUrls: ['./pos-print.page.scss'],
})
export class PosPrintPage implements OnInit {

  @Input() product_info;
  @Input() bill_details;
  @Input() is_order;

  business_info;

  constructor(public print: PrintService, public db: DataService, public modalCtrl: ModalController) { }

  ngOnInit() {

    this.get_business_info();
    // this.qz_print();
    // this.print.print(componentName);
    // console.log(this.bill_details)
    // console.log(this.product_info)

    if (!this.is_order) {
      setTimeout(() => {
        if(localStorage['print_type'] == 'QZ Tray'){
          this.qz_print()
        }
        else
          this.print.print(document.getElementById('order'));
        // this.print.print('order');
        this.modalCtrl.dismiss();
        // window.print()
        // 
      }, 1000)
    }
    this.bill_details = this.product_info
    if (this.is_order)
      this.get_info()

    //   this.db.print_emit.subscribe(x => {
    //     console.log(x)
    //   if (x == 'order') {
    //     this.get_business_info();
    //     this.get_info();
    //     // this.get_cart_items()
    //   }
    // });
  }

  get_business_info(){
    this.db.get_restaturantdetail(localStorage['business']).subscribe((res:any) => {
     // console.log(res)
      if(res.message != undefined)
        this.business_info = res.message[0]
        // console.log("Business info",this.business_info);
    })
  }


  get_weight_k(weight){
      if (weight < 1000) {
        return weight + 'g'
      }
      else if (weight >= 1000) {
        return weight / 1000 + 'kg'
      }
  }

  get_info() {
    // console.log("bill de", this.bill_details)
    // let data = {
    //   business: localStorage.business,
    //   date: this.db.today_date(),
    //   limit_page_length: 10,
    //   limit_start: 0,
    //   order_from: "",
    //   // shipping_method: "SH00001",
    //   status: "Pending"
    // }
    // this.db.get_orders_lists(data).subscribe((res: any) => {

    //   let order_arr = res.message
    //   var check = order_arr.find(obj => obj.name == this.bill_details.name);
    //   if(check)
    //     this.bill_details= check
    //   this.is_order = 0;
    //   // this.bill_details.total_calc = this.calculate_qty(this.bill_details)
    //   console.log("bill details",this.bill_details)
    //   setTimeout(() => {
    //     // this.print.print(document.getElementById('order'));
    //     // this.print.print('order');
    //     this.modalCtrl.dismiss();
    //     this.qz_print()
    //   }, 1000)
    //   // console.log('dasdasdasd', res.message[0])
    //   // this.bill_details = res.message[0]
    // })

    let data = {
      order_id:this.bill_details.name
    }
    this.db.get_order_details(data,1).subscribe((res:any)=>{
      this.bill_details = res.message
      // if(res.message.order)
      //   this.bill_details = res.message.order;
      // if(res.message.shop_user)
      //   this.bill_details.full_name = res.message.shop_user
      if(this.bill_details.order_item)
        this.bill_details.items = this.bill_details.order_item
       setTimeout(() => {
        if(localStorage['print_type'] == 'QZ Tray'){
          this.qz_print()
        }
        else
          this.print.print(document.getElementById('order'));

        this.modalCtrl.dismiss();
        
      }, 1000)

    })


    
  }

  calculate_qty(data) {

    let total_qty = 0;
    // console.log("bill de", this.bill_details)
    if (!this.is_order) {
      this.bill_details.items.map(res => {
        // console.log("res", res.quantity)
        total_qty = total_qty + res.quantity
      })
    }
    // console.log("toalqty", total_qty)
    return total_qty
  }





  // New print code by Bala


  qz_print() {
    //console.log(qz.websocket.isActive())
    if (qz.websocket.isActive()) {

      this.print_data();
    }
    else{
      this.connect().then(() => {
        return this.print_data();
        //return this.print_qr();
      // return this.print_html();
     }).then(() => {
       this.success();              
     }).catch(this.fail);
    }
          
  }
  connect() {
    return new Promise<void>(function (resolve, reject) {
      if (qz.websocket.isActive()) {	// if already active, resolve immediately
        resolve();
      } else {
        // try to connect once before firing the mimetype launcher
        qz.websocket.connect().then(resolve, function retry() {
          // if a connect was not successful, launch the mimetime, try 3 more times
          window.location.assign("qz:launch");
          qz.websocket.connect({ retries: 2, delay: 1 }).then(resolve, reject);
        });
      }
    });
  }
  print_data() {
    var  right = 2.25, left = 2.25;
   // console.log('bill details', this.bill_details)
    var qrsize = {width: 4.28, height: 3.26};
    //var qrconfig = qz.configs.create("POS-80",{units: 'cm', size: qrsize});
    var config = qz.configs.create("POS-80", {encoding: 'ISO-8859-1',units: 'cm', size: qrsize ,margins: {right: right, left: left }});
    config.config.copies = 2   //two copies
  
    var bill_description;
    var items:any = [];
    var item_data;
    var qty_mrp = [];
    var total_qty = 0;
     this.bill_details.items.map(res => {
      total_qty = total_qty + res.quantity  //quantity
    })
    var Token_no,Emp_name
    Token_no=this.bill_details.token?this.bill_details.token:'-'
    Emp_name=this.bill_details.shop_user?this.bill_details.shop_user:'-'
  
    this.bill_details.items.map(res => {

     // console.log('bill_details.item', res)
      bill_description=res.attribute_description?res.attribute_description:''
      
      //  var null_string=null;
      //  var _string= undefined || '' || null_string;
      //  res.attribute_description=_string?res.attribute_description.push('-'): res.attribute_description;
      // console.log("attribute_desac", res.attribute_description)
      var description=''
      if( bill_description&& bill_description.length!=0){
       var myHTML =bill_description;
       var br = myHTML.replace(/<br>/g, '\n');
      description = br.replace(/<[^>]+>/g, '');
      // var description=br;
      //console.log(description);
      }
  
       var ordered_item_name=res.item_name;
       var item_name=ordered_item_name //.replace(/[^a-zA-Z ]/g,"");
       
      // console.log("html content", description);
     // console.log("des", description);


      var weight;
      if (res.weight < 1000) {
        weight = res.weight + 'g'
      }
      else if (res.weight >= 1000) {
        weight = res.weight / 1000 + 'kg'
      }

     
      
  if (res.tray_no) {
        items.push(this.title_space(item_name)+'\x0A'+description+'\x0A'+'\x09' +'\x09' + res.quantity+'\x09' + res.price.toFixed(2)+'\x09'+ res.price.toFixed(2)+'\x09' + res.amount.toFixed(2) + '\x1B' + '\x61' + '\x30' +'\x0A')
        // qty_mrp.push(res.quantity + res.price + res.price + res.amount)
        var item=items.join()
        item_data=item.replace(/,/g,"")
       // console.log("tray",item_data)
      }
      else if (!res.tray_no) {
        // console.log("round", res.price.toFixed(2));
         items.push( '\x1B' + '\x74' + '\x68',this.title_space(item_name) +'\x0A'+description+'\x0A'+'\x09' +'\x09' +res.quantity+'\x09' +  res.price.toFixed(2)+'\x09' +  res.price.toFixed(2)+'\x09' + res.amount.toFixed(2) + '\x1B' + '\x61' + '\x30'+'\x0A')
         //items.push(res.item_name)
         var item=items.join()
         item_data=item.replace(/,/g,"")
         //console.log(item_data)
      }
    })
    var qrcode_img= this.db.product_img(this.bill_details.qrcode);
   // console.log(qrcode_img,this.bill_details);
    var qrdata; 
    var data = [
      '\x1B' + '\x45' + '\x01',
      'GO1' + '\x1B' + '\x61' + '\x31' + '\x1b' + '\x21' + '\x01' +'\x1b' + '\x45' + '\x00'  + '\n', 
      this.title_length(this.business_info.business_address)+ '\x1B' + '\x61' + '\x31' +'\x1b'+'\x21'+'\x01'+'\n',
      this.business_info.city +','+this.business_info.state+','+ this.business_info.country+' '+this.business_info.zip_code+ '\x1B' + '\x61' + '\x31'+ '\n',
      'Phone:' + this.business_info.contact_number + '\x1B' + '\x61' + '\x31'+ '\x1b' + '\x21'+'\x00'+'\x1b'+'\x4D'+'\n'+'\x0A', 
      '\x1B' + '\x45' + '\x0D',//bold on
       this.bill_details.payment_method_name+'\x1B' + '\x45' +'\x0A'+'\x0A', 
      this.get_dashes('\x2D',48) + '\x0A',
      'Bill No: ' + this.bill_details.name + '\x1B' + '\x61' + '\x48'+this.get_space_value("Bill No: ",this.bill_details.name ,"Date: ",this.bill_details.order_date),
      'Date: ' + this.bill_details.order_date + '\x1B' + '\x61' + '\x50'+'\x0A',  
      'Token No: ' + Token_no + '\x1B'+ '\x61'+ '\x30'+this.get_space_value("Token No: ",Token_no ,"Employee Name:",Emp_name),
      'Employee Name:'+Emp_name+'\x0A',
      'Customer Name: ' + this.bill_details.customer_name + '\x1B'+ '\x61'+ '\x30'+'\x0A', 
      'Customer Phone No: '+this.bill_details.phone+ '\x1B'+ '\x61'+ '\x30'+'\x0A',
       this.get_dashes('\x2D',48) + '\x0A',
       '\x1B' + '\x45' + '\x0D' ,// bold on
      'Item Name '+'\x09'+'Qty '+'\x09'+ 'Mrp '+'\x09'+ 'Rate '+'\x09'+ 'Amount ' + '\x1B' + '\x61' + '\x30'+'\x1B'+'\x45'+'\x0A'+'\n', 
        //bold off
        this.get_dashes ('\x2D',48) + '\x0A',  
      // items + '\x1b' + '\x21'+'\x00', 
       item_data + '\x1b' + '\x21'+'\x00', 
        this.get_dashes('\x2D',48) + '\x0A',
      'Total Qty: ' + total_qty + '\x1B' + '\x61' + '\x48'+this.get_space_value("Total Qty: ",total_qty,"Discounts: ",this.bill_details.discount), //'\x09'+'\x09'+'\x09'
      'Discounts: '+this.bill_details.discount + '\x1B' + '\x61' + '\x50' + '\n', 
      'Delivery charge: '+this.bill_details.shipping_charges.toFixed(2)+'\x1B'+ '\x61'+ '\x32'+'\x0A',
      'Total Items: ' +  this.bill_details.items.length + '\x1B' + '\x61' + '\x30'+this.get_space_value("Total Items: ",this.bill_details.items.length,"Total Amount: ",this.bill_details.total_amount.toFixed(2)),
      'Total Amount: ',this.bill_details.total_amount.toFixed(2) + '\x1B' + '\x61' + '\x32' + '\n',  
      this.get_dashes('\x2D',48) + '\x0A',
      '**THANK YOU ! VISIT AGAIN**' + '\x1B' + '\x61' + '\x31'+'\x1b' + '\x2D' + '\x49'+'\n',
      '\x1B' +'\x2D' + '\x49',
      this.get_dashes('\x2D',48) + '\x0A',
       qrdata ='\x1B\x61\x31',{ 
      type: 'raw',
      format: 'image',
      flavor: 'file',
      data:qrcode_img,
      options: {language: "escp", dotDensity: 'double'}
      }
      ,'\x0A\x0A\x0A\x1B\x69', //automatic cut paper 

      // 'Customer Phone No.+91 ' + this.bill_details.phone + '\x1B' + '\x61' + '\x31' + '\n'+'\x0A'+'\x0A'+'\x0A'+'\x0A', 
    ];   
    // console.log("before data",data)


   
     
    return qz.print(config, data);
  }

  // notify successful print
  success() {
    // this.print_qr()
    // alert("Success");
  }
  get_dashes(code,count){
    let dashes =''
    for(let i=0;i<count;i++){
        dashes += code 
    }
    return dashes
 }
//  get_space(data,datatwo){
//     let data_len= data.toString().length    
//     let data_two_len=datatwo.toString().length
//      let space_len = 24 - data_len-data_two_len
//      let space = ''
//      console.log("space length",space_len)
//      for(let i=0;i<space_len;i++){
//        space += ' ' 
//      }
//      return space
//  }

 get_space_value(data1_title,data1_value,data2_title,data2_value){
  //if(data1_title&&data1_value&&data2_title&&data2_value){
  let data1_len= data1_title.toString().length + data1_value.toString().length
  let data2_len=data2_title.toString().length + data2_value.toString().length
   let space_len = 48 - data1_len-data2_len
   let space = ''
   for(let i=0;i<space_len;i++){
     space += ' ' 
   }
   return space
}

 title_space(title:any){
    let title_len = title.length
    let title_value = ''
    for(let i=0;i<title_len;i++){
      if(i!=0 && i%20 == 0){
        title_value += '\n' + title.charAt(i)
      }
      else{
        title_value += title.charAt(i)
      }
    }
    return title_value
 }
 title_length(title){
  let title_len = title.length
  let title_value = ''
  for(let i=0;i<title_len;i++){
    if(i!=0 && i%45 == 0){
      title_value += '\n' + title.charAt(i)
    }
    else{
      title_value += title.charAt(i)
    }
  }
  return title_value
}

  // exception catch-all
  fail(e) {
    alert("Error: " + e);
  }
}
